import React from "react";
import { findAll } from "highlight-words-core";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const styles = {
  destextstyle: {
    color: "white",
    fontFamily: "Lato",
    fontSize: "18px",
    paddingRight: 40,
    lineHeight: 40,
  },
  highlightStyle: {
    backgroundColor: "#ffdcc0",
    color: "white",
    fontFamily: "Lato",
    fontSize: "18px",
    borderRadius: 8,
  },
};

const TextLink = styled.a`
  cursor: pointer;
  font-style: normal;
  margin: 0 5px;
`;

export default function HighlightText(props) {
  const navigate = useNavigate();
  const { persistItemsReducer } = useSelector((state) => state);
  const { loginReducer } = useSelector((state) => state);
  const handleClick = (text) => {
    // if(text.includes("account" || "rekeninggegevens" || "détails du compte")){
    // if(text== "détails du compte"){
    //   navigate("/myaccount")
    //  // window.location.href= "/profile"
    // }else
    if (
      persistItemsReducer?.selectedSOData?.soCode === "NZLO" &&
      loginReducer?.getSOConfiguration?.addNewChildUrl != "" &&
      !text
        ?.toLowerCase()
        ?.includes("account" || "rekeninggegevens" || "détails du compte")
    ) {
      window.location.href = loginReducer?.getSOConfiguration?.addNewChildUrl;
    } else {
      props?.destroyAlert && props?.destroyAlert();
      props?.setNoSponsorChildError && props?.setNoSponsorChildError(false);
      if (persistItemsReducer?.selectedSOData?.soCode === "JPNO" && text) {
        window.open("https://www.worldvision.or.jp/form/child/entry_input）からお申し込みください。", "_blank")

      } else {
        if (window.location.pathname.includes("/home")) {
          navigate("/myaccount", { state: { navigateFrom: "home" } });
        } else {
          navigate("/myaccount");
        }
      }
      //window.location.href= "/SponsorChild"
    }
  };
  if (
    props?.textToHighlight &&
    props?.searchWords &&
    props?.searchWords?.length > 0
  ) {
    const textToHighlight = props?.textToHighlight;
    const searchWords = props?.searchWords;

    const chunks =
      searchWords &&
      textToHighlight &&
      findAll({
        searchWords,
        textToHighlight,
      });
    return (
      <p style={props?.textstyle ? props?.textstyle : styles.destextstyle}>
        {chunks &&
          chunks.map((chunk, index) => {
            const text = textToHighlight.substr(
              chunk.start,
              chunk.end - chunk.start
            );
            return !chunk.highlight ? (
              text
            ) : (
              <TextLink
                key={index}
                onClick={() => handleClick(text)}
                style={
                  chunk.highlight && props?.highlightstyle
                    ? props?.highlightstyle
                    : styles.highlightStyle
                }
              >
                {text}
              </TextLink>
            );
          })}
      </p>
    );
  }
  return null;
}
